import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/images/top_right_arrow.png'


const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-3 h-3 absolute right-7 top-7",
  alt: ""
}, null, -1)

import { ref } from 'vue'

interface Props {
  href: string
  defaultImg: string
  hoverImg: string
  className: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioItem',
  props: {
    href: null,
    defaultImg: null,
    hoverImg: null,
    className: null
  },
  setup(__props: any) {


const isHover = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    target: "_blank",
    href: __props.href,
    class: "flex-1 w-full item bg-scp-black3 h-full flex justify-center items-center rounded-2xl cursor-pointer relative",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([__props.className ? __props.className : '', "flex justify-center items-center"])
    }, [
      _withDirectives(_createElementVNode("img", {
        src: require(`@/images/portfolio/${__props.hoverImg}`),
        alt: "hoverSrc"
      }, null, 8, _hoisted_2), [
        [_vShow, isHover.value]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: require(`@/images/portfolio/${__props.defaultImg}`),
        alt: ""
      }, null, 8, _hoisted_3), [
        [_vShow, !isHover.value]
      ])
    ], 2),
    _hoisted_4
  ], 40, _hoisted_1))
}
}

})